export default __webpack_public_path__ + "static/media/france-flag-icon-free-download.6719408a.jpg";